module.exports = __webpack_public_path__ + "img/release_risk_bg5.393ead4c.jpg";